<app-navbar [title]="'Leady (' + count + ')'">
	<button (click)="addFiles()" class="btn btn-primary me-4"><i class="fas fa-download"></i> Importuj z FB</button>
	<a routerLink="../add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<input type="file" #fileMovie style="display: none" (change)="onFilesAdded($event)" multiple />

<div id="loader" *ngIf="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<app-leads-list-filters
	userFilters="leadsList"
	[statuses]="statuses"
	[types]="types"
	[users]="users"
	[forceFilters]="forceFilters"
	(selected)="filtersSelected($event)"
></app-leads-list-filters>

<app-dynamic-table
	module="leads"
	[elements]="leads"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
<!--
<div class="card">
	<div class="card-body">
		<form (submit)="setNumberOfResults()">
			<div class="form-inline">
				<label for="numberOfResults">Ilość wyników na stronie: </label>
				<select class="form-control" id="numberOfResults" name="countLimit" [(ngModel)]="countLimit">
					<option>50</option>
					<option>200</option>
					<option>500</option>
				</select>
				<button type="submit" class="btn btn-primary ml-2">pokaż</button>
			</div>
		</form>
	</div>
</div>
-->
